import { render, staticRenderFns } from "./system-dialog.vue?vue&type=template&id=5a3388df&scoped=true"
import script from "./system-dialog.vue?vue&type=script&lang=js"
export * from "./system-dialog.vue?vue&type=script&lang=js"
import style0 from "./system-dialog.vue?vue&type=style&index=0&id=5a3388df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3388df",
  null
  
)

export default component.exports